/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBriefcaseArrowLeft = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m9.414 18-3.707 3.707-1.414-1.414L5.586 19H2v-2h3.586l-1.293-1.293 1.414-1.414z" />
        <path d="M17 3v4h5v14H11v-2h9V9H4v4H2V7h5V3zM9 5v2h6V5z" />
      </g>
    </g>
  </Icon>
);
export { SvgBriefcaseArrowLeft as BriefcaseArrowLeft };
